import { useParams, useSearchParams } from "react-router-dom";
import { Accordion, AccordionItem } from "@nextui-org/react";
import Item from "./Item";
import QuizDetail from "./QuizDetail";
import VideoDetail from "./VideoDetail";
import Pagination from "../../../../components/Pagination";
import ContentListSkeleton from "./ContentListSkeleton";

function ContentList({ data, page = 1, totalPages = 1 }) {
    const [, setSearchParams] = useSearchParams();
    const { videoId } = useParams();

    return (
        <aside className="flex-grow bg-background-color rounded-xl">
            <div className="px-2 rounded-lg shadow-sm py-7">
                <h3 className="mb-4 text-2xl text-secondary-color">
                    محتوى{" "}
                    <span className="text-secondary-color">المحاضره </span>
                </h3>
                <div className="w-full xl:w-[420px] min-h-[400px]">
                    {!data && <ContentListSkeleton />}

                    {data && (
                        <Accordion className="flex flex-col gap-4 ">
                            {data.map((item) => {
                                return (
                                    <AccordionItem
                                        classNames={{
                                            base: "bg-white",
                                        }}
                                        className={`w-full px-2 rounded-lg ${
                                            item.isLocked || !item.isAttended
                                                ? "bg-[#E9E9E9]"
                                                : ""
                                        } shadow-md shadow-slate-200 ${
                                            item.id === parseInt(videoId, 10)
                                                ? "border-2 border-primary-color-primary"
                                                : ""
                                        }`}
                                        key={item.id}
                                        aria-label={item.attributes.name}
                                        title={<Item itemDetail={item} />}
                                    >
                                        {item.attributes.type === "video" && (
                                            <VideoDetail
                                                id={item.id}
                                                myViewsCount={item?.myViews}
                                                maxViewsCount={item?.maxViews}
                                                isLocked={item.isLocked}
                                                isAttended={item.isAttended}
                                            />
                                        )}
                                        {item.attributes.type === "quiz" && (
                                            <QuizDetail
                                                isLocked={item.isLocked}
                                                quizData={item}
                                            />
                                        )}
                                    </AccordionItem>
                                );
                            })}
                        </Accordion>
                    )}
                    <div className="flex justify-center w-full">
                        {totalPages > 1 ? (
                            <Pagination
                                setSearchParams={setSearchParams}
                                page={page}
                                total={totalPages}
                                className="mt-5"
                                paginationKey="page"
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>
        </aside>
    );
}

export default ContentList;
